module.exports = __webpack_public_path__ + "img/error.9af2c822.svg";